<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <div class="header">
    <span class="title">Join A league at georgian bowl!</span>
    <span class="text">Stay Active. Feel Great. Have Fun.</span>
  </div>
  <div class="info">
    <div class="items">
      <span class="label">Leagues for All Ages & Skill Levels:</span>
      <div class="item">Adult, Senior & Youth Leagues</div>
      <div class="item">Social, Competitive & Just-for-fun Options</div>
      <div class="item">Meet New People or Bring Your Own Team</div>
    </div>
    <div class="season">
      <span class="label">Season Runs</span>
      <span class="time green">September to May</span>
    </div>
  </div>

  <div class="contacts">
    <div class="line">
      Call
      <span class="phone green">705-445-3871</span>
      or Visit the
    </div>
    <div>Front Desk to Sign Up!</div>
  </div>
</div>
